import React__default from 'react';
import { SvgImg } from '../../components/svgImg/svgImg.js';

const Check = ({ width = '16', height = '16', fill = 'none', className = '', }) => (React__default.createElement(SvgImg, { viewbox: "0 0 16 16", title: "app", width: width, height: height, fill: fill, extraClass: className },
    React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15 3.707L14.293 3L5.5 11.7925L1.707 8L1 8.707L5.5 13.207L15 3.707Z", fill: "#D80000", stroke: "#D80000", strokeWidth: "0.5" })));

export { Check };
